import { useEffect } from "react";

/**
 * Lightweight per-route SEO: sets document.title and the meta description.
 * Restores nothing on unmount — the next route sets its own values.
 */
export function useSeo(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
